import { render } from "./payment_fees.vue?vue&type=template&id=1be8fb8c&scoped=true"
import script from "./payment_fees.vue?vue&type=script&lang=js"
export * from "./payment_fees.vue?vue&type=script&lang=js"

import "./payment_fees.vue?vue&type=style&index=0&id=1be8fb8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be8fb8c"]])

export default __exports__